import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PiecesSection from "@/components/feature/PiecesSection";
import ServicesSection from "@/components/feature/ServicesSection";
import { pvcPieces, pvcServices } from "@/mocks/servicesSections";
import VideoDiagnostic from "@/components/feature/VideoDiagnostic";
import { useSEO } from "@/hooks/useSEO";
import { seoData } from "@/data/seoData";
import ContactForm from "@/pages/home/components/ContactForm";
import GoogleReviews from "@/components/feature/GoogleReviews";
import Hero from "./components/Hero";
import PVCIntro from "./components/PVCIntro";
import WhatWeRepair from "./components/WhatWeRepair";
import AllBrands from "./components/AllBrands";
import RepairNotReplace from "./components/RepairNotReplace";
import FAQ from "./components/FAQ";
import Gallery from "./components/Gallery";
import InternalLinks from "./components/InternalLinks";
import FloatingButton from "./components/FloatingButton";

export default function FenetrePVCPage() {
  useSEO(seoData.fenetrePVC);
  return (
    <>
      <Header />
      <main>
        <Hero />
        <VideoDiagnostic />
        <PiecesSection {...pvcPieces} />
        <ServicesSection {...pvcServices} />
        <PVCIntro />
        <WhatWeRepair />
        <AllBrands />
        <RepairNotReplace />
        <FAQ />
        <Gallery />
        <InternalLinks />
        <GoogleReviews />
        <ContactForm />
      </main>
      <Footer />
      <FloatingButton />
    </>
  );
}